import React, { useState } from 'react'
import { Toggle, ToggleProps } from 'builder/components/Toggle/Toggle'
import * as Styles from './styles'

type Props = {
  label?: string
  paddingFeatures?: boolean
  header: string
  description: string
  featureTitle: string
  featureList: string[]
  footerNote: string | React.ReactNode
  onToggle: (value: boolean) => void
} & ToggleProps

export const ToggleCard = ({
  label,
  header,
  description,
  featureTitle,
  featureList,
  footerNote,
  paddingFeatures,
  onToggle,
  ...rest
}: Props) => {
  const [checked, setChecked] = useState(rest.checked)

  const onClickCard = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    onToggle(!checked)
    setChecked(!checked)
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(e.target.checked)
    setChecked(e.target.checked)
  }

  return (
    <Styles.Conatiner onClick={onClickCard}>
      <Styles.HeaderContainer $hasLabel={!!label}>
        <Styles.TextContainer>
          <Styles.Header>{header}</Styles.Header>
          <Styles.Description>{description}</Styles.Description>
        </Styles.TextContainer>
        <Styles.ToggleContainer $hasLabel={!!label}>
          <Toggle {...rest} checked={checked} onChange={onChange} />
          {label && <Styles.Label>{label}</Styles.Label>}
        </Styles.ToggleContainer>
      </Styles.HeaderContainer>
      <Styles.FeaturesContainer $addPadding={paddingFeatures}>
        <Styles.FeatureTitle>{featureTitle}</Styles.FeatureTitle>
        <Styles.Features>
          {featureList.map(feature => (
            <Styles.Feature key={feature}>
              <Styles.FeatureIconContainer>
                <Styles.FeatureIcon />
              </Styles.FeatureIconContainer>
              <Styles.FeatureText dangerouslySetInnerHTML={{ __html: feature }} />
            </Styles.Feature>
          ))}
        </Styles.Features>
      </Styles.FeaturesContainer>
      <Styles.FooterContainer>
        <Styles.FooterText>{footerNote}</Styles.FooterText>
      </Styles.FooterContainer>
    </Styles.Conatiner>
  )
}
